import { render } from "./editing.vue?vue&type=template&id=12cfc296"
import script from "./editing.vue?vue&type=script&lang=js"
export * from "./editing.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./editing.vue?vue&type=style&index=0&id=12cfc296&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__